import { Plus } from 'lucide-react';
import MyButtonMain from './MyButtonMain';
import MyLucideIcon from '../myIcon/MyLucideIcon';

const MyButtonSuccess = ({ withIcon, ...otherProps }) => {
  return (
    <MyButtonMain
      {...otherProps}
      color="green"
      variant="solid"
      icon={
        withIcon ? (
          <MyLucideIcon icon={Plus} size={18} style={{ marginTop: 2 }} />
        ) : null
      }
    />
  );
};

export default MyButtonSuccess;
